<div class="inner-card-header">
  <div class="d-flex align-items-center">
    <h3 class="card-title">
      {{ title | translate }}
    </h3>
    <button
      mat-icon-button
      type="button"
      *ngIf="!tempNew && !tempEditnewCreateItem && !isAnonymized"
      (click)="createNew()"
      class="cursor-pointer add-icon p-btn-primary smaler-size-btn">
      <mat-icon>add</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      *ngIf="tempNew && !isAnonymized"
      (click)="closeCreatenew()"
      class="cursor-pointer add-icon p-btn-primary smaler-size-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div [formGroup]="currentForm">
  <div>
    <div *ngIf="tempNew" class="inner-card-section new-item">
      <div class="field-body text-center w-100">
        <div class="d-flex flex-column align-items-start">
          <div class="d-flex w-100">
            <p class="rightHeadings">
              {{ placeholder | translate }}
            </p>
            <span class="text-danger">*</span>
          </div>
          @if (current === 'skillName') {
            <app-skill-selector
              [allCVOptionsFromDB]="allCVOptionsFromDB"
              [placeholder]="placeholder | translate"
              [appearance]="'outline'"
              [cssClass]="'small w-100'"
              [testId]="'card-item-skill'"
              [formControlName]="current">
            </app-skill-selector>
          } @else {
            <mat-form-field appearance="outline" class="small w-100">
              <input
                type="text"
                placeholder="{{ 'stepperForm.examplePlaceHolders.pickOne' | translate }}"
                aria-label="type"
                matInput
                [formControlName]="current"
                [matAutocomplete]="auto" />
              <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayWith">
                <mat-option *ngFor="let item of filtered | async" [value]="item">
                  {{ translationPrefix ? (translationPrefix + item | translate) : item }}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          }
          <div class="d-flex w-100">
            <p class="rightHeadings">
              {{ 'stepperForm.language.level' | translate }}
            </p>
            <span class="text-danger">*</span>
          </div>
          <mat-form-field appearance="outline" class="second-btn small w-100">
            <mat-select formControlName="level" matNativeControl>
              <mat-option *ngFor="let item of levels" [value]="item">
                {{ item | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="new-item-nav mb-3 d-flex justify-content-evenly">
        <button type="button" mat-flat-button data-first-save (click)="closeCreatenew()" class="p-btn-light">
          {{ 'shared.close' | translate }}
        </button>
        <button type="button" mat-flat-button (click)="saveNew()" [disabled]="!currentForm?.valid" class="p-btn-primary">
          {{ 'shared.save' | translate }}
        </button>
      </div>
    </div>

    <div class="expansion-content">
      <div class="d-flex justify-content-between" *ngFor="let item of items; let i = index">
        <mat-accordion class="w-100" [multi]="!edit ? true : false">
          <mat-expansion-panel #panel [hideToggle]="true">
            <mat-expansion-panel-header
              style="cursor: default"
              #panelH
              (click)="panelH._toggle()"
              class="header-no-hover"
              [ngClass]="{ 'border-bottom': edit }">
              <mat-panel-title>
                <span *ngIf="edit" class="w-100">{{ translationPrefix ? (translationPrefix + item[current] | translate) : item[current] }}</span>
                <span *ngIf="!edit" class="w-100">{{ translationPrefix ? (translationPrefix + item[current] | translate) : item[current] }}</span>
              </mat-panel-title>
              <mat-panel-description class="d-flex justify-content-end" [ngStyle]="{ 'margin-right': !edit ? '.5rem' : '0' }">
                <span *ngIf="edit">{{ item.level | translate }}</span>
                <span *ngIf="!edit" class="w-100 text-right">{{ item.level | translate }}</span>
                <div class="d-flex pe-2">
                  @if ((!edit || step !== i) && !isAnonymized) {
                  <button
                    (click)="editItem(i, panel)"
                    mat-icon-button
                    type="button"
                    class="mat-icon-edit"
                    [ngStyle]="{ cursor: !edit ? 'pointer' : 'default' }">
                    <mat-icon matTooltip="{{ 'shared.edit' | translate }}">edit</mat-icon>
                  </button>
                  } @if (edit && step === i && !isAnonymized) {
                  <button (click)="removeItem(i, panel)" mat-icon-button type="button" class="mat-icon-edit">
                    <mat-icon matTooltip="{{ 'dashboardSettings.userManagement.delete' | translate }}" class="danger">delete_forever</mat-icon>
                  </button>
                  <button (click)="saveEditItem(i, panel)" mat-icon-button type="button" class="mat-icon-edit">
                    <mat-icon matTooltip="{{ 'shared.save' | translate }}">save</mat-icon>
                  </button>
                  <button (click)="closeEditItem(i, panel)" mat-icon-button type="button" class="mat-icon-edit">
                    <mat-icon class="danger" matTooltip="{{ 'shared.cancel' | translate }}">cancel</mat-icon>
                  </button>
                  }
                </div>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <div class="d-flex flex-column align-start ml-3 pt-3" [ngClass]="{ 'another-items': i >= 1 }">
              @if (edit) {
              <div class="d-flex w-100">
                <p class="rightHeadings">
                  {{ 'stepperForm.language.language' | translate }}
                </p>
                <span class="text-danger">*</span>
              </div>
              @if (current === 'skillName') {
                <app-skill-selector
                  [allCVOptionsFromDB]="allCVOptionsFromDB"
                  [placeholder]="'stepperForm.examplePlaceHolders.pickOne' | translate"
                  [appearance]="'outline'"
                  [cssClass]="'small w-100'"
                  [testId]="'card-item-skill-edit'"
                  [initialExpandedCategory]="editingSkillCategory"
                  [formControlName]="current">
                </app-skill-selector>
              } @else {
                <mat-form-field appearance="outline" class="small w-100">
                  <input
                    type="text"
                    placeholder="{{ 'stepperForm.examplePlaceHolders.pickOne' | translate }}"
                    aria-label="type"
                    matInput
                    [formControlName]="current"
                    [matAutocomplete]="auto" />
                  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayWith">
                    <mat-option *ngFor="let filteredItem of filtered | async" [value]="filteredItem">
                      {{ translationPrefix ? (translationPrefix + filteredItem | translate) : filteredItem }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              }
              }
            </div>
            <div class="d-flex flex-column align-start ml-3">
              <div *ngIf="!edit" class="d-flex w-100">
                <p>{{ 'stepperForm.language.level' | translate }}:</p>
                <span>{{ item.level | translate }}</span>
              </div>
              @if (edit) {
              <div class="d-flex w-100">
                <p class="rightHeadings">
                  {{ 'stepperForm.language.level' | translate }}
                </p>
                <span class="text-danger">*</span>
              </div>
              <mat-form-field appearance="outline" class="small w-100">
                <mat-select formControlName="level" matNativeControl required>
                  <mat-option *ngFor="let level of levels" [value]="level">
                    {{ level | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              }
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</div>
